export default __webpack_public_path__ + "static/media/footerinsta.e6c190b3.svg";